module.exports = __webpack_public_path__ + "static/media/21ECLAC28.cfc70a0e.jpg";